// Scoring helpers shared by the report views and exports.
// DIMENSION_WEIGHTS mirrors backend cv_models.DIMENSION_WEIGHTS — keep in sync.

export const DIMENSION_WEIGHTS = {
  "Formatting and Structure": 0.15,
  "Content Relevance": 0.3,
  "Language and Style": 0.15,
  "Cultural and Market Fit": 0.15,
  "Strategic Positioning": 0.25,
};

// Qualitative band for a 0-10 score; keys map to i18n `score.band.*`.
export function scoreBand(score) {
  const s = Number(score) || 0;
  if (s >= 8.5) return "excellent";
  if (s >= 7) return "strong";
  if (s >= 5) return "fair";
  if (s >= 3) return "weak";
  return "poor";
}

// Visual tone (color family) for a 0-10 score — matches the ScoreRing tones.
export function scoreTone(score) {
  const s = Number(score) || 0;
  if (s >= 8) return "high";
  if (s >= 5) return "mid";
  if (s >= 3) return "low";
  return "poor";
}

export const BAND_CHIP_CLASS = {
  excellent: "bg-success-light text-success border-success/25",
  strong: "bg-primary-light text-primary border-primary/25 dark:text-accent-foreground",
  fair: "bg-muted text-muted-foreground border-border",
  weak: "bg-warning-light text-warning border-warning/25",
  poor: "bg-destructive/10 text-destructive border-destructive/25",
};

export const TONE_BAR_CLASS = {
  high: "bg-success",
  mid: "bg-primary",
  low: "bg-warning",
  poor: "bg-destructive",
};

// Finnish-style score formatting: 7 -> "7", 6.5 -> "6,5".
export function formatScore(score) {
  const s = Math.round((Number(score) || 0) * 10) / 10;
  return String(s).replace(".", ",");
}
